import React, { createContext, useContext } from 'react';
import { useDayChange } from '../hooks/useDayChange';
import { getLocalDateString } from '@shared/utils/dateUtils';

const DayContext = createContext<string | null>(null);

export const DayProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const localDate = useDayChange();
    return <DayContext.Provider value={localDate}>{children}</DayContext.Provider>;
};

export function useDay(): string {
    const value = useContext(DayContext);
    if (value !== null) return value;
    // Fallback if used outside provider
    return getLocalDateString();
}
